import { useAppDispatch, useAppSelector } from '../../utils/hooks'
import { actionFetchUserData, selectUserData } from '../../slices/user/userSlice'
import { useCallback, useEffect } from 'react'
import { getAuth, User } from 'firebase/auth'
import { User as FirebaseUser } from '@firebase/auth'
import useFirebaseAuthentication from '../../../utils/Firebase/hooks/useFirebaseAuthentication'

export function useActionFetchUser() {
	const dispatch = useAppDispatch()
	const userData = useAppSelector(selectUserData)
	const { loading, authUser } = useFirebaseAuthentication()

	useEffect(() => {
		if (!loading) {
			const user = authUser as User
			if (user) {
				dispatch(actionFetchUserData(user.uid))
			}
		}
	}, [dispatch, loading, authUser])

	const reloadUserData = useCallback(() => {
		const auth = getAuth()
		const user = auth.currentUser as FirebaseUser
		if (user) {
			dispatch(actionFetchUserData(user.uid))
		}
	}, [dispatch])

	return {
		userData: userData.data,
		loading: userData.status === 'pending',
		subscribed: userData?.data?.subscription_status?.toLowerCase() === 'subscribed',
		reload: reloadUserData,
	}
}
